module.exports = __webpack_public_path__ + "static/media/ht.050fe782.svg";